import qs from 'qs'

export type SessionTransferParams = {
  sessionTransferToken: string
  cognitoUsername: string
}

/**
 * Reads the session transfer hash params the Admin Panel sets when opening
 * this tab (see `buildSessionTransferUrl` in the Temporary Backoffice
 * Sessions area). Both params must be present, otherwise this is a normal
 * login page visit.
 */
export const parseSessionTransferParams = (
  hash: string,
): SessionTransferParams | null => {
  const parsed = qs.parse(hash.replace(/^#/, ''))
  const { sessionTransferToken, cognitoUsername } = parsed

  if (
    typeof sessionTransferToken !== 'string' ||
    typeof cognitoUsername !== 'string' ||
    !sessionTransferToken ||
    !cognitoUsername
  ) {
    return null
  }

  return { sessionTransferToken, cognitoUsername }
}
